const locationSelector = state => state.router.location;
export const pathnameSelector = state => locationSelector(state).pathname;
export const searchSelector = state => locationSelector(state).search;
export const filterSelector = state => locationSelector(state).filter;
